import ChartSaveToolbar from "../MyChartsPage/ChartSaveToolbar";
import classes from "./PreviewScalePage.module.css";
import PublishScalePage from "./PublishScalePage";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { ChartWorkflow } from "../ChartWorkflow";
import { useRef } from "react";
import PreviewDownloads from "./PreviewDownloads";

const PreviewScalePage = (props) => {
  const published = useRef(null);
  return (
    <div className={classes.container}>
      <HelmetProvider>
        <Helmet>
          <meta charset="UTF-8" />
          <title>
            Guitar Charts Designer - Preview
          </title>
          <meta
            name="description"
            content="Guitar Charts Designer is a web app that lets you create and print custom guitar charts and diagrams."
          />
        </Helmet>
      </HelmetProvider>
      <div className={classes.scrollArea}>
        <div className={classes.previewControls}>
          <ChartWorkflow step={3} />
          <div className={classes.saveCard}>
            <ChartSaveToolbar compact allowCopy={false} />
            <PreviewDownloads publishedRef={published} />
          </div>
        </div>
        <div ref={published}><PublishScalePage onClick={props.onClick}/></div>
      </div>
    </div>
  );
};

export default PreviewScalePage;
